import { KeyboardEvent, useCallback } from 'react'

export function useEnterAction<T extends HTMLElement = HTMLInputElement>(
  callback: (e?: KeyboardEvent<T>) => void,
) {
  return useCallback(
    (e: KeyboardEvent<T>) => {
      if (e.key === 'Enter') {
        e.preventDefault()
        if (callback) {
          callback(e)
        }
      }
    },
    [callback],
  )
}
